import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { appContext } from 'common/contexts';
import { Routes as R } from 'common/enums';
import { PlusTwoTone, EditSquareOutlineTwoTone, TrashCanOutlineTwoTone } from 'common/icons';
import { Recipe } from 'common/types';
import InventoryNav from '../inventoryItemsList/inventoryNav';
import styles from './recipesList.module.css';

const RecipesList: React.FC = () => {
  const { state, actions, helpers } = useContext(appContext);
  const { recipes = [], items = [] } = state;
  const { translation } = helpers;
  const { t } = translation;
  const [loading, setLoading] = useState(false);

  const handleDelete = async (recipeId: string) => {
    if (window.confirm(t('common.confirm'))) {
      try {
        setLoading(true);
        await actions.inventory.removeRecipe(recipeId);
      } catch (error) {
        console.error('Error deleting recipe:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  const getProductName = (productId: string) => {
    const product = items.find(item => item.id === productId);
    return product ? product.name : t('common.deletedItem');
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>{t('admin.inventory.title')}</h1>
      </div>
      
      <InventoryNav />
      
      <div className={styles.header}>
        <h2 className={styles.title}>{t('admin.inventory.recipes.title')}</h2>
        <Link to={R.RecipeCreate} className={styles.addButton}>
          <PlusTwoTone className={styles.addButtonIcon} />
          {t('admin.inventory.recipes.addRecipeLabel')}
        </Link>
      </div>

      <div className={styles.tableContainer}>
        {recipes && recipes.length > 0 ? (
          <table className={styles.table}>
            <thead>
              <tr>
                <th>{t('admin.inventory.recipes.product')}</th>
                <th>{t('admin.inventory.recipes.ingredients')}</th>
                <th>{t('common.actions')}</th>
              </tr>
            </thead>
            <tbody>
              {recipes.map((recipe) => (
                <tr key={recipe.id}>
                  <td>{getProductName(recipe.productId)}</td>
                  <td>
                    <span className={styles.ingredientCount}>
                      {t('admin.inventory.recipes.ingredientCount', { count: recipe.ingredients.length })}
                    </span>
                  </td>
                  <td>
                    <div className={styles.actions}>
                      <Link 
                        to={R.RecipeEdit.replace(':id', recipe.id)} 
                        className={styles.actionButton}
                      >
                        <EditSquareOutlineTwoTone />
                      </Link>
                      <button 
                        className={styles.actionButton} 
                        onClick={() => handleDelete(recipe.id)}
                        disabled={loading}
                      >
                        <TrashCanOutlineTwoTone />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className={styles.emptyState}>
            <div className={styles.emptyStateIcon}>📝</div>
            <p>{t('admin.inventory.recipes.emptyListMessage')}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RecipesList;
